module.exports = "../../static/fonts/WorkSans-Medium.816c43c.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/WorkSans-Medium.ttf
// module id = 924
// module chunks = 2